import { render, staticRenderFns } from "./RequestAnAssignmentForm.vue?vue&type=template&id=2e26d820&scoped=true&"
import script from "./RequestAnAssignmentForm.vue?vue&type=script&lang=js&"
export * from "./RequestAnAssignmentForm.vue?vue&type=script&lang=js&"
import style0 from "./RequestAnAssignmentForm.vue?vue&type=style&index=0&id=2e26d820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e26d820",
  null
  
)

export default component.exports